import { InjectionToken, Provider } from '@angular/core';
import { Observable, filter, map } from 'rxjs';
import { Store } from '@ngrx/store';

import { selectConfig } from '../../root-store/app-store/selectors';

export const CONSOLE_API_ROOT = new InjectionToken<Observable<string>>('CONSOLE_API_ROOT');

export function provideConsoleApiRoot(): Provider {
	return {
		deps: [Store],
		provide: CONSOLE_API_ROOT,
		useFactory: (fatStore: Store) => fatStore.select(selectConfig).pipe(filter(Boolean),map(config => config.apiUrl))
	}
}